export default __webpack_public_path__ + "static/media/186.75e96d92.jpg";